export default __webpack_public_path__ + "static/media/logo.1692b638.png";